jQuery(document).ready(function($){

	if ( itr.current_page == "welcome" ){
	var mq = {};

		if (matchMedia) {
		  var mq = window.matchMedia("(max-width: 768px)");
		  mq.addListener(WidthChange);
		  WidthChange(mq);
		}

		function WidthChange(mq) {
		  if (mq.matches) {
		  	$('.videoWrapper').slick({});
		  	$('.descargables').slick({});		
		  } else {
		  	if ( $('.descargables').hasClass('slick-slider') ){
		  		$('.descargables').slick('unslick');
		  	}
		  	if ( $('.videoWrapper').hasClass('slick-slider') ){
		  		$('.videoWrapper').slick('unslick');
		  	}
		  }
		}
	}
});
